import imageUrlBuilder from "@sanity/image-url";
import type { SanityImageSource } from "@sanity/image-url/lib/types/types";
import { useEffect, useRef } from "react";

import { getClient } from "./sanityClient";

export const urlFor = (source: SanityImageSource) => {
  const sanityClient = getClient();
  return imageUrlBuilder(sanityClient).image(source).auto("format").dpr(2);
};

export const useUrlFor = (source: SanityImageSource) => {
  const sanityClient = getClient();

  const devicePixelRatio = useRef(2);

  useEffect(() => {
    if (typeof document !== undefined) {
      devicePixelRatio.current = window.devicePixelRatio;
    }
  }, [source]);

  return imageUrlBuilder(sanityClient).image(source).auto("format").dpr(devicePixelRatio.current);
};
